# This controller exists to put in workarounds for old Angular1 pages that don't
# really need controllers, yet need to access the window to check env vars.

angular.module('wbControllers').controller 'WorkaroundController',

['$scope', '$window', ($scope, $window) ->
  @env = $window.process.env
  @accountApplicationPath = @env.ACCOUNT_APPLICATION_PATH

  @
]
